import { createBrowserRouter } from 'react-router-dom'
import { UberEats } from './uber-eats'
import { SumniCloudPrinter } from './sumni-cloud-printer'
import { FaxPlus } from './fax-plus'
import { EPOSNow } from './epos-now'
import { MealzoOrderInjector } from './mealzo-order-injector'
import { StuartDelivery } from './stuart-delivery'
import { UberDirectDelivery } from './uber-direct-delivery'
import { NashDelivery } from './nash-delivery'
import { RelayDelivery } from './relay-delivery'
import { ToastPOS } from './toast'
import { MealShiftDelivery } from './mealshift-delivery'
import { StockhubPOS } from './stockhub-pos'
import { MealzoPaymentHandler } from './mealzo-order-injector/payments'
import { CloverPOS } from './clover-pos'
import { JustEat } from './just-eat'
import { DeliverySimulator } from './delivery-simulator'
import { DeliverooMarketplace } from './deliveroo'

/**
 * Router for the top level of the application
 */
export const router = createBrowserRouter([
  { path: '/', element: <>Hello World 1</> },
  { path: '/uber-eats', index: true, element: <UberEats /> },
  { path: 'clover-pos', index: true, element: <CloverPOS /> },
  { path: 'just-eat', index: true, element: <JustEat /> },
  { path: 'sumni-cloud-printer', index: true, element: <SumniCloudPrinter /> },
  { path: 'fax-plus', index: true, element: <FaxPlus /> },
  { path: 'epos-now', index: true, element: <EPOSNow /> },
  { path: 'stuart-delivery', index: true, element: <StuartDelivery /> },
  {
    path: 'uber-direct-delivery',
    index: true,
    element: <UberDirectDelivery />,
  },
  { path: 'nash-delivery', index: true, element: <NashDelivery /> },
  { path: 'relay-delivery', index: true, element: <RelayDelivery /> },
  { path: 'toast', index: true, element: <ToastPOS /> },
  { path: 'mealshift-delivery', index: true, element: <MealShiftDelivery /> },
  { path: 'deliveroo', index: true, element: <DeliverooMarketplace /> },
  { path: 'stockhub-pos', index: true, element: <StockhubPOS /> },
  { path: 'delivery-simulator', index: true, element: <DeliverySimulator /> },
  {
    path: 'mealzo-order-injector',

    children: [
      {
        index: true,
        element: <MealzoOrderInjector />,
      },
      {
        path: 'payments',
        element: <MealzoPaymentHandler />,
      },
    ],
  },
])
